/**
 * Listens to our app channel for requests to change the current domain.
 *
 * The app menu and the main submenu both contain clickable links that change the current domain.
 * 
 * @package Ninja Forms builder
 * @subpackage Main App
 * @copyright (c) 2015 WP Ninjas
 * @since 3.0
 */
/* global _, jBox, jQuery, nfAiChat, nfRadio */
define( 'controllers/app/menuButtons',[], function() {
	var controller = Marionette.Object.extend( {
		/**
		 * Register app-menu listeners, including the AI Assistant entry point.
		 *
		 * @return {void}
		 */
		initialize: function() {
			this.listenTo( nfRadio.channel( 'app' ), 'click:publish', this.publish );
			this.listenTo( nfRadio.channel( 'app' ), 'click:viewChanges', this.viewChanges );
			this.listenTo( nfRadio.channel( 'app' ), 'click:publicLink', this.publicLink );
			this.listenTo( nfRadio.channel( 'app' ), 'click:aiAssistant', this.aiAssistant );
		},

		/**
		 * Publish the current form unless AI recovery has blocked persistence.
		 *
		 * @return {void}
		 */
		publish: function() {
			if (
				'undefined' !== typeof nfAiChat &&
				true === nfAiChat.recoveryBlocked
			) {
				nfRadio
					.channel( 'notices' )
					.request(
						'add',
						'ai-recovery-required',
						nfAiChat.i18n.recoveryRequired
					);
				return;
			}
			nfRadio.channel( 'app' ).request( 'update:db', 'publish' );
		},

		viewChanges: function() {
			var changeCollection = nfRadio.channel( 'changes' ).request( 'get:collection' );
			nfRadio.channel( 'app' ).request( 'open:drawer', 'viewChanges', { collection: changeCollection } );
		},

		publicLink: function() {
			nfRadio.channel( 'app' ).request( 'open:drawer', 'publicLink' );
		},

		/**
		 * Open the builder AI Assistant drawer.
		 *
		 * A form built by hand has no row yet, and the conversation, the
		 * attached model and every edit are all filed against the form's id.
		 * Rather than hide the control, which taught reviewers that AI worked
		 * only on AI-generated forms, ask for a name and save it first. The
		 * builder's own publish dialog would answer the same question without
		 * saying why it was being asked.
		 *
		 * @return {void}
		 */
		aiAssistant: function() {
			var formModel = nfRadio.channel( 'app' ).request( 'get:formModel' );
			var connected = 'undefined' !== typeof nfAiChat &&
				nfAiChat.providers &&
				nfAiChat.providers.length;
			/*
			 * With nothing connected the drawer answers with the connect
			 * explanation, so asking for a name and saving the form first would
			 * charge the administrator a publish before telling them the
			 * feature cannot run yet.
			 */
			if ( connected && formModel && isNaN( formModel.get( 'id' ) ) ) {
				this.saveFormThenAssist();
				return;
			}
			nfRadio.channel( 'app' ).request( 'open:drawer', 'aiAssistant' );
		},

		/**
		 * Name and save an unsaved form, then open the assistant on it.
		 *
		 * @return {void}
		 */
		saveFormThenAssist: function() {
			var that = this;
			var settings = nfRadio.channel( 'settings' ).request( 'get:settings' );
			var template = nfRadio
				.channel( 'app' )
				.request( 'get:template', '#tmpl-nf-ai-save-first' );
			var copy = ( 'undefined' !== typeof nfAiChat && nfAiChat.i18n ) || {};
			var modal = new jBox( 'Modal', {
				title: copy.saveFirstTitle || '',
				width: 480,
				content: template( { title: settings.get( 'title' ) || '' } ),
				closeButton: 'title'
			} );

			modal.open();

			jQuery( '.nf-ai-save-first-cancel' ).on( 'click', function( e ) {
				e.preventDefault();
				modal.close();
			} );

			jQuery( '.nf-ai-save-first-go' ).on( 'click', function( e ) {
				e.preventDefault();
				var title = jQuery( '.nf-ai-save-first-title' ).val().trim();
				if ( ! title ) {
					jQuery( '#nf-ai-save-first-error' )
						.text( copy.saveFirstRequired || '' )
						.show();
					jQuery( '.nf-ai-save-first-title' ).trigger( 'focus' );
					return;
				}
				settings.set( 'title', title );
				modal.close();
				that.publishThenAssist();
			} );
		},

		/**
		 * Publish through the builder's own path, then open the assistant.
		 *
		 * Publishing is delegated to the confirmPublish controller rather than
		 * repeated here, so the submit-button rule, the show_publish_options
		 * reset and the update:db call all live in one place. The publish
		 * options drawer that normally answers the add_submit question is the
		 * dialog this modal replaced, so we answer it the same way that drawer
		 * does before handing off: a form that already has a submit button does
		 * not get another, and a form without one does. confirmPublish then
		 * publishes synchronously, so the response listener is attached first.
		 *
		 * @return {void}
		 */
		publishThenAssist: function() {
			var fields = nfRadio.channel( 'fields' ).request( 'get:collection' );
			var settings = nfRadio.channel( 'settings' ).request( 'get:settings' );
			settings.set( 'add_submit', fields.findWhere( { type: 'submit' } ) ? 0 : 1 );
			var opened = function( response ) {
				if ( ! response || 'publish' !== response.action ) {
					return;
				}
				nfRadio.channel( 'app' ).off( 'response:updateDB', opened );
				var minted = _.values(
					( response.data &&
						response.data.new_ids &&
						response.data.new_ids.forms ) ||
						{}
				);
				var newId = Number( minted.length ? minted[ 0 ] : 0 );
				if ( ! newId ) {
					return;
				}
				if ( 'undefined' !== typeof nfAiChat ) {
					nfAiChat.formId = newId;
				}
				nfRadio.channel( 'app' ).request( 'open:drawer', 'aiAssistant' );
			};
			nfRadio.channel( 'app' ).on( 'response:updateDB', opened );
			nfRadio.channel( 'app' ).trigger( 'click:confirmPublish' );
		}

	});

	return controller;
} );

